let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("i6g8e")).then(() => parcelRequire('8wK7s'));